import { gl } from '../context.js';
var cache = {};

var shaderProgram;

function CompileShader(src, type) {
  var shader = gl.createShader(type);
  gl.shaderSource(shader, src);
  gl.compileShader(shader);

  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    console.error(gl.getShaderInfoLog(shader));
    return null;
  }

  return shader;
}

function LinkProgram(vertexShader, fragmentShader) {
  var program = gl.createProgram();

  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);
  gl.linkProgram(program);

  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    console.error('Could not initialise shaders');
  }

  return program;
}

function Program(vertex, fragment) {
  // shaders
  var vertexShader = CompileShader(vertex, gl.VERTEX_SHADER);
  var fragmentShader = CompileShader(fragment, gl.FRAGMENT_SHADER);

  // program
  var program = LinkProgram(vertexShader, fragmentShader);

  return program;
}

function Attributes(program) {
  var attributes = {};
  var count = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);

  for (var i = 0; i < count; i++) {
    var attrib = gl.getActiveAttrib(program, i);
    attributes[attrib.name] = gl.getAttribLocation(program, attrib.name);
  }

  return attributes;
}

function Uniforms(program) {
  var uniforms = {};
  var count = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);

  for (var i = 0; i < count; i++) {
    var uniform = gl.getActiveUniform(program, i);
    uniforms[uniform.name] = gl.getUniformLocation(program, uniform.name);
  }

  return uniforms;
}

// return shader object
function Shader(text) {
  var source = text.split('// ###');
  var program = Program(source[0], source[1]);
  gl.useProgram(program);

  // attributes & uniforms
  var attributes = Attributes(program);
  var uniforms = Uniforms(program);

  // returned promise
  return {
    program,
    attributes,
    uniforms
  };
}

export { Shader }
